import { Descriptions, Typography } from 'antd';
import styled from '@emotion/styled';

const StyledDescriptions = styled(Descriptions)`
  .ant-btn.ant-btn-link.ant-btn-variant-link {
    height: var(--line-height);
  }
`;

const AccountDescriptions = ({ title, ...descriptionsProps }) => {
  return (
    <div>
      {title && (
        <Typography.Title
          level={5}
          style={{ paddingLeft: 'var(--spacing-xxs)' }}
        >
          {title}
        </Typography.Title>
      )}
      <StyledDescriptions
        size="small"
        bordered={true}
        column={2}
        {...descriptionsProps}
      />
    </div>
  );
};

export default AccountDescriptions;
